import React from 'react';
import classnames from "classnames";

import Modal from './../shared/Modal';
import Button from './../shared/Button';


import baseStyles from 'custom/base.styl';

const IntroModal = props => {
  const { onStart, subjectType } = props;

  return (
    <Modal className={classnames(baseStyles.modal, baseStyles.modal_space)}>
      <h1>Are you ready?</h1>
      <h2>Go through the tutorial, complete two short test tasks, and get ready for the hundreds of orders waiting for you!</h2>
      {subjectType !== 'math' && subjectType !== 'finance' &&
        <p>Quality is the most important thing for us and we do want you to succeed on our platform. That is why we have prepared a short tutorial for you to familiarize yourself with the platform standards and understand how to achieve them.</p>
      }
      {(subjectType === 'math' || subjectType === 'finance') &&
        <p>Quality delivered to our Clients is of the utmost importance for us and, sure thing, we want you to succeed on the platform. That is why we have prepared a short tutorial that focuses on the key academic requirements and gives you some valuable tips and tricks so you familiarize yourself with our standards and have a better understanding of our expectations. Let's do it!</p>
      }
      <Button onClick={onStart} block>Start tutorial</Button>
    </Modal>
  );
};

export default IntroModal;



// WEBPACK FOOTER //
// ./src/components/Tutorial/IntroModal.js